import script from "./statistics.vue?vue&type=script&setup=true&lang=js"
export * from "./statistics.vue?vue&type=script&setup=true&lang=js"

import "./statistics.vue?vue&type=style&index=0&id=2b6b8314&lang=css"

const __exports__ = script;

export default __exports__